export default {"src":"/_next/static/media/calculateMetadata.cd74fce9.svg","height":761,"width":1354,"blurWidth":0,"blurHeight":0};